// @ts-check
/* eslint-disable import/prefer-default-export */

/**
 * Maps locale unsupported by some browsers to fallbacks array
 */
const LOCALE_FALLBACKS = {
  // 'no' macrolanguage isn't supported by modern browsers (Chrome, Firefox, Edge)
  'no-NO': ['no-NO', 'nb', 'nn', 'da']
};

/**
 * @param {number} value
 * @param {string} locale A string with a BCP 47 language tag
 */
export function formatPrice(value, locale) {
  const locales = LOCALE_FALLBACKS[locale] || locale;

  const formatter = new Intl.NumberFormat(locales, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  
  return formatter.format(value);
}
